// external
import { region } from '../localizations/current-locale';
import { dynamicBrand } from '../utils/brand';

// internal
import { valid, invalid } from '../utils/validators/resolutions';

let messages;
import(`../utils/text-resources/${dynamicBrand()}/${region}/messages`).then((m) => {
  messages = m.default;
});

const validateNumCurrentLoans = (input = '') => {
  if (!/\S+/.test(input || '')) {
    return invalid(messages.numCurrentLoansIsRequired);
  }

  if (!/^(\d+)$/.test(input)) {
    return invalid(messages.numCurrentLoansUseOnlyNumbers);
  }

  const value = parseInt(input, 10);

  if (value < 0) {
    return invalid(messages.tooLowNumCurrentLoans);
  }

  if (value > 10) {
    return invalid(messages.tooHighNumCurrentLoans);
  }

  return valid();
};

export default validateNumCurrentLoans;
